import { render, staticRenderFns } from "./orderPayDialog.vue?vue&type=template&id=07a05887&scoped=true"
import script from "./orderPayDialog.vue?vue&type=script&lang=js"
export * from "./orderPayDialog.vue?vue&type=script&lang=js"
import style0 from "./orderPayDialog.vue?vue&type=style&index=0&id=07a05887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a05887",
  null
  
)

export default component.exports